module.exports = __webpack_public_path__ + "static/img/before6.4de8029.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/before6.jpg
// module id = o/us
// module chunks = 9